import axios from "axios";
import $ from "jquery";
import {CATFISH} from "Core/entities/links";
import {isMobile} from "Core/screenSizes";
import {MAX_MOBILE_WIDTH} from "Core/screenSizes";
import {
    adViewAndClickHandlers,
    changeAdFox,
    getAdsMapByPlace,
    changeParentBlock,
    getExceptedAdsIdBySessionPlace
} from "./general-handlers";

const DEFAULT_TIMEOUT = 3000;
const PLACE = 'catfish';
const MOBILE_PLACE = 'mobile_catfish';

export const showCatfish = () => {
    setTimeout(function () {
        renderCatfish();
    }, DEFAULT_TIMEOUT);
};

const renderCatfish = () => {
    if (window.isHideAds !== undefined) {
        if (!isMobile() && window.isHideAds[PLACE] !== undefined) {
            return;
        }

        if (isMobile() && window.isHideAds[MOBILE_PLACE] !== undefined) {
            return;
        }
    }

    const place = isMobile() ? MOBILE_PLACE : PLACE;

    axios.get(CATFISH, {
        params: {
            isMobile: isMobile(),
            mapViews: getAdsMapByPlace(place),
            exceptedIdList: getExceptedAdsIdBySessionPlace(place),
        }
    })
        .then((response) => {
            let str = changeAdFox(response.data);
            str = changeParentBlock(str);

            $('#catfish-block').html(str);

            $('#catfish-modal__button').click(function () {
                $('#catfish-modal').remove();
            });

            if (str.indexOf('adfox') === -1) {
                $('#catfish-block').show();
                $('#catfish-modal').show();
            }

            adViewAndClickHandlers();
        });
};
